import React from 'react'

import { Typography } from '@material-ui/core'
import { TitleView } from 'ui/components'

import Container from './styles'

export default function () {
  return (
    <Container>
      <TitleView
        type="Configurações"
        title="Plano"
        subtitle="Exibe o plano"
      />

      <div className="main">
        <h1>Esta seção foi movida.</h1>
        <Typography>
          Para acessar clique nos 3 pontos ao lado do seu nome, depois em Configurações e por fim em Planos CPF ou Planos CNPJ.
        </Typography>
        <Typography>
          Para saber mais mais veja a documentação, clique nos 3 pontos ao lado do seu nome, depois em Documentação e por fim em Plano.
        </Typography>
      </div>
    </Container>
  )
}
